<template lang="pug">
  .content
    .content__block.content-contacts
      div.content-contacts__item
        p
          span.camp-content__subtitle Руководитель программы:&#32;
          span.camp-content__text {{contacts.fio}}
        p
          span.camp-content__subtitle Email:&#32;
          span.camp-content__text {{contacts.email}}
        p
          span.camp-content__subtitle Телефон:&#32;
          span.camp-content__text {{contacts.phone}}
</template>

<script>

export default {
  name: "ShiftContacts",
  props: {
    contacts: {
      type: Object,
      default: () => ({})
    }
  }

};
</script>
